import { logger } from '../../../util/logger';
import { renderModel } from '../../../util/renderModel';
import { httpClient } from '../../httpClient';
import { UploadUrlResponse } from './types';

const overrideMimeTypeMap: Record<string, string> = {
  'image/x-pentax-pef': 'image/x-raw-pentax', // image/x-pentax-pef currently is not in the allowed list. Will be added in the next version
  'image/x-panasonic-rw2': 'image/x-raw-panasonic',
  'image/x-minolta-mrw': 'image/x-raw-minolta', // Will be added in the next version
};

export const getUploadUrl = async (file: File, mediaAuthToken: string | null): Promise<UploadUrlResponse> => {
  try {
    const mimeType = overrideMimeTypeMap[file.type] ?? file.type;
    const { data } = await httpClient
      .getInstance()
      .get<UploadUrlResponse>(
        `https://files.wix.com/site/media/files/upload/url?file_name=${file.name}&mime_type=${mimeType}`,
        {
          headers: {
            authorization: `APP ${mediaAuthToken}`,
          },
        },
      );

    return data;
  } catch (error) {
    logger.error({
      message: 'fail to get upload url and token',
      error,
      callParams: renderModel.get(),
    });
    throw error;
  }
};
